export default {
  name: 'my-parallax',
  template: `
    <div class="o-parallax">
      <div class="o-parallax__inner" ref="parallax">
        <slot></slot>
      </div>
    </div>
  `,
  data () {
    return {
      item: null,
      scene: null,
      section: null
    }
  },
  mounted () {

  }
}



// WEBPACK FOOTER //
// ./src/components/standard/my-parallax.js